import { useState } from "react";
import { CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { submitBroker } from "@/lib/docstate";

export default function DocstateListWithUs() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", agency: "", rera_brn: "", areas: "", note: "" });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim() || !form.email.trim()) {
      toast.error("Please add your name, phone and email");
      return;
    }
    setSending(true);
    try {
      await submitBroker(form);
      setDone(true);
      toast.success("Registration received — our team will be in touch");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Submission failed. Please check your details.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="ds-bg min-h-screen pt-16" data-testid="docstate-list-with-us">
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-8 lg:px-12">
        <p className="ds-eyebrow">List With Docstate</p>
        <h1 className="ds-display mt-2 text-3xl font-medium text-white lg:text-4xl">Partner & Broker Registration</h1>
        <p className="mt-3 max-w-xl text-sm text-[#C9BBB2]">
          Are you a property owner or a RERA-registered broker? Register with Docstate to list your properties and collaborate with our sales team across Dubai.
        </p>

        {done ? (
          <div className="ds-card mt-8 flex flex-col items-center gap-3 p-10 text-center" data-testid="broker-success">
            <CheckCircle2 className="h-12 w-12 text-[#3CB98A]" />
            <p className="ds-display text-2xl text-[#F3E5AB]">Thank you, {form.name.split(" ")[0]}</p>
            <p className="max-w-md text-sm text-[#C9BBB2]">Your registration has been received. A member of the Docstate team will review it and reach out shortly.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="ds-card mt-8 p-6 sm:p-8" data-testid="broker-form">
            <div className="grid gap-4 sm:grid-cols-2">
              <div><label className="ds-eyebrow mb-1.5 block">Full Name *</label><input value={form.name} onChange={set("name")} data-testid="broker-name" className="ds-input" /></div>
              <div><label className="ds-eyebrow mb-1.5 block">Agency / Company</label><input value={form.agency} onChange={set("agency")} data-testid="broker-agency" className="ds-input" /></div>
              <div><label className="ds-eyebrow mb-1.5 block">Phone *</label><input value={form.phone} onChange={set("phone")} data-testid="broker-phone" placeholder="+9715..." className="ds-input" /></div>
              <div><label className="ds-eyebrow mb-1.5 block">Email *</label><input type="email" value={form.email} onChange={set("email")} data-testid="broker-email" className="ds-input" /></div>
              <div><label className="ds-eyebrow mb-1.5 block">RERA BRN</label><input value={form.rera_brn} onChange={set("rera_brn")} data-testid="broker-rera" placeholder="BRN-xxxxx" className="ds-input" /></div>
              <div><label className="ds-eyebrow mb-1.5 block">Areas Covered</label><input value={form.areas} onChange={set("areas")} data-testid="broker-areas" placeholder="e.g. Marina, Downtown" className="ds-input" /></div>
            </div>
            <div className="mt-4"><label className="ds-eyebrow mb-1.5 block">Message</label><textarea value={form.note} onChange={set("note")} rows={4} data-testid="broker-note" placeholder="Tell us about your portfolio or what you'd like to list" className="ds-input resize-none" /></div>
            <button type="submit" disabled={sending} data-testid="broker-submit" className="ds-gold-btn mt-6 w-full px-6 py-3.5 text-sm disabled:opacity-60">
              {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : null}{sending ? "Submitting..." : "Register with Docstate"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
